import axios from 'axios';

const genkeys = require("rezauthlib");
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});

export default {
  install(app) {
    app.mixin({
      methods: {
        $proxyCheck() {
          if (!this.setbrandid) return;
          
          const data = { brand_id: this.setbrandid };
          const secsaa = genkeys(
            encryptStorage.getItem("rez_dev_k").VUE_APP_SRCHANA_SECRETID,
            encryptStorage.getItem("rez_dev_k").VUE_APP_SRCHANA_SECRETKEY
          );
          
          axios.post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO + "srchana/iplatlon",
            data,
            {
              headers: {
                b1: secsaa.b1s,
                v2: secsaa.v2s,
                c2s: secsaa.c2s,
                a1: secsaa.a1,
                v1: secsaa.v1,
                c1: secsaa.uidgen,
                secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_SRCHANA_SECRETID,
                secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_SRCHANA_SECRETKEY,
                "Content-Type": "application/json",
              },
            }
          ).then((response) => {
            const response_data = JSON.parse(response.request.response);
            if (response_data) {
              const { anonymous = "false", proxy = "false", vpn = "false", tor = "false" } = response_data;
              if (anonymous === "true" || proxy === "true" || vpn === "true" || tor === "true") {
                window.location.href = "/proxycheck.html";
              }
            }
          });
        }
      }
    });
  }
};
